import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// HTML의 <div id="root"> 요소를 찾아 리액트의 뿌리(root)를 만듭니다.
const root = ReactDOM.createRoot(document.getElementById('root'));

// 그 안에 우리의 메인 컴포넌트인 <App />을 그립니다.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);